<template>
  <base-modal
    v-if="showAddonsModal"
    @close="closeModals"
  >
    <template #heading>
      Your Add-ons
    </template>

    <div class="scroll-area">
      <manage-addons-form
        ref="addonsForm"
        :user-addons="addons"
        :hide-button="true"
        @submit="submit"
      />
    </div>

    <template #footer>
      <primary-button
        size="md"
        :disabled="loading"
        @click="$refs.addonsForm.validateAndSubmit()"
      >
        <i
          v-if="loading"
          class="fas fa-spin fa-spinner"
        />
        Continue
      </primary-button>
    </template>
  </base-modal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ManageAddonsForm from '../includes/ManageAddonsForm';
import Swal from 'sweetalert2';
import BaseModal from "../../global/modals/BaseModal";
import PrimaryButton from "../../global/buttons/PrimaryButton";

export default {
  components: {
    PrimaryButton,
    BaseModal,
    ManageAddonsForm,
  },
  emits: [
    'addons-updated',
  ],
  computed: {
    ...mapGetters('stripeConnectDashboard', [
      'showAddonsModal',
    ]),
    ...mapGetters('productManager', [
      'loading',
    ]),
    ...mapGetters('addonManager', [
      'addons',
    ]),
  },
  methods: {
    ...mapActions('stripeConnectDashboard', [
      'closeModals',
    ]),
    ...mapActions('productManager', [
      'setLoadingState',
    ]),
    ...mapActions('addonManager', [
      'updateAddons',
    ]),
    submit() {
      this.setLoadingState(true);
      this.updateAddons().then(() => {
        Swal.fire({
          icon: "success",
          title: "Success!",
          // TODO: Better messaging, just want to let users know they can leave and return.
          text: 'Your add-on offerings have been updated.',
        });
        this.closeModals();
        this.$emit('addons-updated');
        this.setLoadingState(false);
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  button {
    margin-left: auto;
  }
</style>
